import { z } from 'zod';

import { type AnyZodSchema } from '@Common/types/zod/utils';

export const createZodArrayable = <T extends AnyZodSchema>(schema: T) =>
  z.union([schema, z.array(schema)]);
